import { makeStyles } from '@material-ui/core/styles';
import { TextColors } from '@/utils/constants';
import { hoverBackground } from '@/utils/styles/hoverBackground';

const useNavigationDropdownItemStyles = makeStyles(({ spacing }) => ({
  wrapper: {
    textAlign: 'left',
  },
  root: {
    '&[data-navigation-dropdown-item]': {
      // being more specific to override muiButtonBase styles
      display: 'block',
      color: TextColors.light,
      padding: spacing(1.5, 0),
      fontSize: '15px',
      textAlign: 'left',
      cursor: 'pointer',
      position: 'relative',
      whiteSpace: 'normal',
      width: '100%',
    },
    '& > span': {
      zIndex: 1,
      position: 'relative',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    '&::before': {
      left: 0,
      top: '50%',
      width: '1px',
      height: '0%',
      content: '""',
      opacity: 0,
      position: 'absolute',
      transform: 'translateY(-50%)',
      transition: 'opacity 150ms ease-in-out 0s, height 250ms ease-in-out 0s',
      backgroundColor: 'rgb(0, 174, 239)',
      zIndex: 1,
    },
    '&.hovered:hover , &.isActive': {
      '&::before': {
        opacity: '1 !important',
        height: 'calc(100% - 24px) !important',
      },
    },
    '& .navigation-item-text-content': {
      padding: spacing(0, 1.5),
      lineHeight: '16px',
    },
    ...hoverBackground({
      muiTheme: { spacing },
      selector: ':after',
      position: {
        top: '4px',
        left: '0px',
        right: '0px',
        bottom: '4px',
      },
    }),
  },
  dropdownItemLabel: {
    display: 'inline-block',
    margin: spacing(0, 1, 0, 0),
  },
  arrowIcon: {
    transition: 'all .3s',
  },
  visible: {
    visibility: 'visible',
  },
  hidden: {
    visibility: 'hidden',
  },
}));

export default useNavigationDropdownItemStyles;
